import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'uikit';
import WarningIcon from "@/assets/images/icons/16/warning.svg";
import styles from './Confirm.module.scss';
import {ConfirmPropsInterface} from "@/views/Admin/Events/Event/Promocodes/Confirm/Confirm.props.interface";

const Confirm = ({data, onConfirm, onDecline}: ConfirmPropsInterface) => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        if (onConfirm) {
            setActive(true);
        }
    }, [onConfirm]);

    const handleClose = () => {
        setActive(false);
        onDecline?.();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm?.();
        handleClose()
    };

    return (
        <Modal
            className={styles.container}
            active={active}
            onActive={setActive}
            onMissClick={handleClose}
            onEscape={handleClose}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.icon}><WarningIcon/></div>
                <div className={styles.content}>
                    <h6>
                        Внимание
                    </h6>
                    <p className={styles.description}>
                        Вы уверены, что хотите выполнить это действие?
                    </p>
                    <div className={styles.btns}>
                        <Button type="tertiary" theme="ghost" size="small" onClick={handleClose}>
                            Отмена
                        </Button>
                        <Button type="tertiary" theme="default" size="small" onClick={handleSubmit}>
                            Удалить
                        </Button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default Confirm;
